import { Icon, theme } from '@lmc/ui-kit'
import styled from 'styled-components'

interface FormWarningProps {
  message: string
}

export const FormWarning = ({ message }: FormWarningProps) => {
  return (
    <WarningWrapper>
      <Icon
        name="ExclamationCircleFilled"
        size={14}
        color={theme.color.neutral.color4}
      />
      <WarningText>{message}</WarningText>
    </WarningWrapper>
  )
}

const WarningWrapper = styled.div`
  border-radius: ${(props) => props.theme.properties.borderRadius.small};
  padding: 8px;
  display: flex;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.color.neutral.color9};
  color: ${(props) => props.theme.color.neutral.color4};
  align-items: center;
`

const WarningText = styled.span`
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-family: ${(props) => props.theme.font.family.sansSerif};
  line-height: 20px;
`
